import Template from './index.vue';

function createLoading({Vue}) {
  Vue.component('loading', Template);
  let Constructor = Vue.extend(Template);
  let instance = new Constructor();
  document.body.appendChild(instance.$mount().$el);
  return instance
}

const plugin = (Vue) => {
  let $vm = createLoading({Vue})
  Vue.prototype.$loading = (function () {
    const start = function (text) {
      $vm.status = true;
      text && ($vm.text = text);
    }
    const stop = function () {
      $vm.status = false;
    }
    return {start, stop}
  })();
}

export default {install: plugin};
